import { DocumentoGenerado } from './../../admin/bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/response-documento-generado';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { DocumentosEmitidosService } from 'app/modules/admin/bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/documentos-emitidos.service';
import { UtilsService } from 'app/modules/utils-service';   
import { CONSTANTS } from 'app/core/constants';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertMessageComponent } from '../dialog.component';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'generated-documents',
    templateUrl: 'generated-documents.component.html',
    imports:[
        CommonModule,
        MatTableModule,
        MatIconModule,
        MatMenuModule,

        HasPermissionsDirective,
    ]
})

export class GeneratedDocumentsComponent implements OnInit {
    @Input() documentos: DocumentoGenerado[]= []
    @Output() abrirDrawer = new EventEmitter<any>();
    @Input() bienCulturalUuid:string

    private modalRef?: MatDialogRef<AlertMessageComponent>;

    idEstaoCertificado = CONSTANTS.ID_ESTADO_CERTIFICADO;

    constructor(
        private documentosEmititosService:DocumentosEmitidosService,
        private utilsService:UtilsService,
        public dialog: MatDialog,
        private router:Router
    ) { }

    ngOnInit() { }

    descargar(){}

    downloadFile(documento: any): void {
        this.documentosEmititosService.getDocumentoBlob(documento.documentoGeneradoUuid)
            .then(blob => {
                this.utilsService.downloadFile(blob, documento.nombre, 'pdf');
            })
            .catch(error => {
                console.error('Error al obtener el archivo:', error);
            });
    }

    certificarDocumento(documento: DocumentoGenerado) {
        this.utilsService.open_confirm_dialog(
            `Está seguro que desea Certificar el documento ${documento.nombre}`, 
            `Certificar Documento`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
                this.abrirModal()
                this.documentosEmititosService.certificarDocumento(documento.documentoGeneradoUuid, this.bienCulturalUuid)
                .then((response) => {
                    this.cerrarModal()
                    this.utilsService.openSuccessSnakBar('Documento certificado correctamente')
                    this.documentosEmititosService.getDocumentosGenerados(this.bienCulturalUuid)
                })
                .catch((error) => {
                    this.cerrarModal()
                });
            }
        })
    }

    eliminarDocumento(documento: DocumentoGenerado) {

        this.utilsService.open_confirm_dialog(
            `Está seguro que desea Eliminar el documento ${documento.nombre}`, 
            `Eliminar Documento`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
                this.documentosEmititosService.deleteDocumentoGenerado(documento.documentoGeneradoUuid, this.bienCulturalUuid)
                .then((response) => {
                    this.utilsService.openSuccessSnakBar('Documento eliminado correctamente')
                    this.documentosEmititosService.getDocumentosGenerados(this.bienCulturalUuid)
                })
            }
        })
    }

    async mostrarArchivoDrawer(documento?:any) {
        this.abrirDrawer.emit(documento);
    }

    verDetalleDocumento(documento_uuid:string){
        this.router.navigate(['/documentos-oficiales/detalle/', documento_uuid]);
    }

    abrirModal(){
        this.modalRef = this.dialog.open(AlertMessageComponent, {
                        panelClass: ['w-full', 'md:w-4/12'],
                        maxHeight: 'calc(100vh - 4rem)',
                        disableClose:true,
                        data:{
                            title: 'Certificando documento',
                            message: 'Por favor, espere mientras se completa el proceso de certificación.'
                        }
                    })
    }

    cerrarModal() {
        this.modalRef?.close();
    }

}